import { createFileRoute, Link, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin/growth-plan")({
  component: GrowthPlanLayout,
  head: () => ({ meta: [{ title: "Growth Plan - KCN Admin" }, { name: "robots", content: "noindex,nofollow" }] }),
});

function GrowthPlanLayout() {
  return (
    <div>
      <div className="mb-6 flex flex-wrap items-center gap-4 border-b border-border pb-4">
        <h1 className="headline-md mr-4">Growth Plan Tool</h1>
        <span className="border border-primary px-2 py-1 text-[0.6rem] uppercase tracking-[0.18em] text-primary">Internal</span>
        <nav className="ml-auto flex items-center gap-5 text-xs uppercase tracking-[0.16em]">
          <Link to="/admin/growth-plan" search={{ id: undefined }} activeOptions={{ exact: true }} className="text-foreground/65 hover:text-foreground" activeProps={{ className: "text-primary" }}>Calculator</Link>
          <Link to="/admin/growth-plan/records" className="text-foreground/65 hover:text-foreground" activeProps={{ className: "text-primary" }}>Records</Link>
          <Link to="/admin/growth-plan/settings" className="text-foreground/65 hover:text-foreground" activeProps={{ className: "text-primary" }}>Settings</Link>
          <Link to="/admin/audits" className="text-foreground/65 hover:text-foreground" activeProps={{ className: "text-primary" }}>Audit Reports</Link>
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
